/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { messaging_ChildBriefResponse } from './messaging_ChildBriefResponse';
import type { messaging_ConversationTargetResponse } from './messaging_ConversationTargetResponse';
import type { messaging_ParticipantResponse } from './messaging_ParticipantResponse';
import type { models_ConversationType } from './models_ConversationType';
import type { models_SenderType } from './models_SenderType';
export type messaging_ConversationResponse = {
    allow_comments?: boolean;
    audience: messaging_ConversationResponse.audience;
    /**
     * Category is general, callback_request or wellbeing_check.
     */
    category: messaging_ConversationResponse.category;
    child?: messaging_ChildBriefResponse | null;
    child_id?: string | null;
    /**
     * Children is every child the thread is about, sorted by name; absent when it names none.
     */
    children?: Array<messaging_ChildBriefResponse>;
    created_at?: string;
    created_by_id?: string;
    created_by_type?: models_SenderType;
    /**
     * FirstStaffReplyAt is the time of the first employee or admin message; absent until then.
     */
    first_staff_reply_at?: string | null;
    id?: string;
    initial_message_id?: string;
    last_message_at?: string;
    /**
     * LastMessagePreview is the first 140 characters of the newest non-deleted message. Set on the parent conversation list only.
     */
    last_message_preview?: string | null;
    /**
     * LastMessageSenderName is the display name of that message's sender; null when unresolvable. Set on the parent conversation list only.
     */
    last_message_sender_name?: string | null;
    message_count?: number;
    participants?: Array<messaging_ParticipantResponse>;
    subject?: string;
    target_id?: string;
    target_type?: string;
    /**
     * Targets is the full live target set of a staff conversation or of a parent-created family thread; absent otherwise and when no target is live.
     */
    targets?: Array<messaging_ConversationTargetResponse>;
    type?: models_ConversationType;
    unread_count?: number;
};
export namespace messaging_ConversationResponse {
    export enum audience {
        FAMILY = 'family',
        STAFF = 'staff',
    }
    /**
     * Category is general, callback_request or wellbeing_check.
     */
    export enum category {
        GENERAL = 'general',
        CALLBACK_REQUEST = 'callback_request',
        WELLBEING_CHECK = 'wellbeing_check',
    }
}

